import {useContext} from 'react';
import {TranslationContext} from '../Context/TranslationContext';

/**
 * Retourne une fonction t(key, variables) liée à un fichier de contexte de
 * traduction donné (ex. 'Tickets.json'), pour éviter de le répéter à chaque appel.
 */
export function useTranslation(context) {
    const {translation} = useContext(TranslationContext);
    return (key, variables) => translation(key, context, variables);
}
